export default {
  apply: [
  ],
  credit: [
  ],
  loan: [
  ],
  mortgage: [
  ],
  contact: [
  ]
};
